import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { signInServiceName as signInServiceNameSelector } from '~/platform/user/authentication/selectors';
import {
  SERVICE_PROVIDERS,
  CSP_IDS,
} from '~/platform/user/authentication/constants';

import { ProfileInfoSection } from '../../ProfileInfoSection';

/**
 * only id.me and login.gov use email for sign in / show the sign-in email section.
 * See issue [#47070](https://va.ghe.com/software/va.gov-team/issues/47070)
 *
 * @param {string} signInServiceName - sign in service from CSP_IDS
 * @returns {boolean} true if the sign in service uses email
 */
const signInServiceUsesEmail = signInServiceName => {
  const servicesUsingEmailSignIn = [CSP_IDS.ID_ME, CSP_IDS.LOGIN_GOV];
  return servicesUsingEmailSignIn.includes(signInServiceName);
};

const generateRows = signInServiceName => {
  const { link, label: buttonText } =
    SERVICE_PROVIDERS[signInServiceName] || {};
  return [
    {
      title: 'Sign-in email and phone number',
      value: (
        <>
          <span>
            Update your sign-in information on the {buttonText} website. This
            includes multifactor authentication (MFA) settings.
          </span>
          <p>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sign-in-email-link"
            >
              {`Update your sign-in information at ${buttonText}`}
            </a>
          </p>
        </>
      ),
    },
  ];
};

const LoginInformationSection = ({ signInServiceName }) => {
  if (!signInServiceUsesEmail(signInServiceName)) {
    return null;
  }

  return (
    <ProfileInfoSection
      title={`${SERVICE_PROVIDERS[signInServiceName]?.label} information`}
      level={2}
      namedAnchor="login-information"
      data={generateRows(signInServiceName)}
      className="vads-u-margin-bottom--6"
    />
  );
};

LoginInformationSection.propTypes = {
  signInServiceName: PropTypes.string.isRequired,
};

export const mapStateToProps = state => ({
  signInServiceName: signInServiceNameSelector(state),
});

export default connect(mapStateToProps)(LoginInformationSection);
